export default "__VITE_ASSET__xSZMkHSp__"